<template>
  <vonap-window
    :modal="true"
    :visible="value"
    transition="dialog-scale-transition"
    title="Send mail"
    width="320px"
    height="217px"
    @close="close"
  >
    <v-layout row justify-center>
      <v-card>
        <v-container grid-list-xl text-xs-center style="height:132px;width:302px">
          <v-layout row wrap>
            <v-flex xs12 style="margin-top:-32px;height:65px">
              <vonap-toolbar-label>
                <v-switch v-model="testMode" label="Send TEST" />
              </vonap-toolbar-label>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-show="testMode"
                v-model="testEmail"
                type="email"
                label="Send To"
                required
                :rules="[v => !!v || 'Email is required!']"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="spacer"></div>
          <v-btn block color="primary" @click="save" :disabled="sending">
            <v-progress-circular indeterminate v-if="sending" />
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import VonapWindow from '@/components/VonapWindow'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import notification from '@/helpers/notification'

export default {
  name: 'DashboardBonCoupConfirmForm',
  components: {
    VonapWindow,
    VonapToolbarLabel,
  },
  props: {
    value: {type: Boolean},
    monthlyReportSendingId: {type: Number},
    asOfDate: {type: String, defaultValue: null},
    analystEmail: {type: String},
    responsibleEmail: {type: String},
  },
  mounted() {
    this.testEmail = this.currentUsername
  },
  data() {
    return {
      testMode: true,
      testEmail: '',
      sending: false,
      jobPollingInterval: null,
    }
  },
  methods: {
    async save() {
      const data = {
        testMode: this.testMode,
        testEmail: this.testEmail,
        asOfDate: this.asOfDate,
        monthlyReportSendingId: this.monthlyReportSendingId,
        monthlyReportSendingListDetailId: -1,
        url: location.origin,
      }
      if (this.testMode) {
        await this.send(data)
      } else {
        data.testEmail = ''
        if (confirm('Are you sure you want to email the client?')) {
          await this.send(data)
        }
      }
    },
    async send(data) {
      this.sending = true
      let url
      if (data.monthlyReportSendingId === 0) {
        url = '/api/report/MonthlyReportSendingList/MultipleSendBonCoupMail'
        data = {
          asOfDate: data.asOfDate,
          analystEmail: this.analystEmail,
          responsibleEmail: this.responsibleEmail,
          testMode: data.testMode,
          testEmail: data.testEmail,
          url: location.origin,
        }
      } else {
        url = '/api/report/MonthlyReportSendingList/SendBonCoupMail'
      }

      try {
        const response = await axios.post(url, data)
        if (response.data.success) {
          if (response.data.jobId) {
            // For multiple sends (background job)
            notification(`Email sending started: Processing ${response.data.itemCount} items`)
            this.startJobPolling(response.data.jobId)
            this.close()
          } else {
            // For single send (immediate response)
            notification('Email sent successfully')
            this.close()
          }
        } else {
          notification(response.data.message || 'Failed to send email', 'error')
        }
      } catch (error) {
        notification('An error occurred while sending the email', 'error')
      } finally {
        this.sending = false
      }
    },
    async startJobPolling(jobId) {
      // Initial delay before first poll
      await new Promise(resolve => setTimeout(resolve, 2000))

      // Poll every 3 seconds
      this.jobPollingInterval = setInterval(async () => {
        try {
          const response = await axios.get(
            `/api/report/MonthlyReportSendingList/GetJobStatus/${jobId}`,
          )
          if (response.data.success) {
            const jobState = response.data.data
            if (jobState.state === 'Processing') {
              this.$emit('progress', jobState)
            }

            if (jobState.inSucceededState || jobState.inFailedState) {
              clearInterval(this.jobPollingInterval)

              if (jobState.inSucceededState) {
                notification('Email sending completed successfully')
              } else {
                notification('Job failed to complete', 'error')
              }
            }
          } else {
            clearInterval(this.jobPollingInterval)
            notification('Failed to get job status', 'error')
          }
        } catch (error) {
          clearInterval(this.jobPollingInterval)
          notification('Error checking job status', 'error')
        }
      }, 3000)
    },
    close() {
      if (this.jobPollingInterval) {
        clearInterval(this.jobPollingInterval)
      }
      this.sending = false
      this.$emit('input', false)
    },
  },
  beforeDestroy() {
    if (this.jobPollingInterval) {
      clearInterval(this.jobPollingInterval)
    }
  },
  computed: {
    ...mapGetters({currentUsername: 'authentication/currentUsername'}),
  },
}
</script>
